<template>
    <v-card >
        <v-toolbar flat color="primary" dark height="40" >
            <v-toolbar-title>Notes</v-toolbar-title>
        </v-toolbar>

        <v-card-text v-if="messages.length">
            <v-layout row wrap>
                <v-flex xs12 pb-2 v-for="note in messages" :key="note.id">
                    <div>
                        {{note.notes}} 
                    </div>
                    <div class="caption text-xs-right pr-5">
                        <i>{{note.systemNotes}}</i>
                    </div>
                    <div class="caption text-xs-right pr-5">
                        <i>{{note.updateDate}} By {{note.updateBy}}</i>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-text v-else>
            <div class="warning--text">No Record Found</div>
        </v-card-text>

    </v-card>
</template>
<script>
export default {
    props: ['quoteData'],
    data () {
        return {}
    },
    computed: {
        messages () {
            return this.quoteData.messages?this.quoteData.messages:[]
            // return []
        }
    },
    methods: {
    }
}
</script>
